import { ViewToggleButton } from '@/components/atoms';
import type { DateFilter } from '@/types/scheduling-api';

/**
 * ViewToggleGroup — Component
 * Segmented control for switching between calendar views.
 * Maps to the `filter` field in AppointmentsRequest.
 */

interface ViewToggleGroupProps {
  value: DateFilter;
  onChange: (view: DateFilter) => void;
  /**
   * Views to offer. Defaults to every practitioner view; the calendar's
   * Devices tab (PROD-2007) narrows it to Day + Week.
   */
  views?: readonly DateFilter[];
}

const VIEWS: DateFilter[] = ['Day', 'Week', 'Month', 'Room', 'Doctor'];

export function ViewToggleGroup({ value, onChange, views = VIEWS }: ViewToggleGroupProps) {
  return (
    <div className="flex bg-grey-100 rounded-lg p-1" role="tablist" aria-label="Calendar view">
      {views.map((v) => (
        <ViewToggleButton
          key={v}
          label={v}
          isActive={value === v}
          onClick={() => onChange(v)}
        />
      ))}
    </div>
  );
}
